import { required, minLength, maxLength, choices } from "react-admin";

export const validateTitle = [required(), minLength(5), maxLength(40)];
export const validateDesc = [required(), minLength(5)];
export const requiredField = [required()];
